import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import ResctrictedAccessSVG from 'images/restrictedAccess.svg';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { translate } from 'containers/services/translate';
import messages from 'containers/AppContainer/messages';
import { BUTTON_COLORS } from 'constants/design';
import mailBoxIcon from 'images/mail-box.svg';
import callIcon from 'images/call-icon.svg';
import styled from 'styled-components';

export interface RestrictedAccessPageProps {
  intl: IntlShape;
}

const ButtonContainer = styled.div`
  .title-button {
    margin-left: 5px;
    color: #1175c9;
    text-transform: lowercase;
  }
  .title-button-secondary {
    margin-left: 5px;
    color: #ffffff;
  }
`;

const RestrictedAccessPage: React.FC<RestrictedAccessPageProps> = (
  props,
): JSX.Element => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
  >
    <img src={ResctrictedAccessSVG} width="20%" alt="restricted" />
    <div
      style={{
        fontSize: '40px',
        fontWeight: 'bold',
        margin: '30px',
        textAlign: 'center',
      }}
    >
      {translate({ ...messages.restrictedAccess }, props)}
      <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#727A83' }}>
        {translate({ ...messages.restrictedAccessDescription }, props)}
      </div>
      <ButtonContainer>
        <PrimaryButton
          title={translate({ ...messages.MailServiceDesk }, props)}
          background={BUTTON_COLORS.BLUE_BUTTON_TITLE}
          lefticon={<img src={mailBoxIcon} alt="mailBox" />}
          border={BUTTON_COLORS.PRIMARY_BLUE}
          titleclass="title-button"
          style={{ width: '100%', height: '100%' }}
        />
        <div style={{ margin: '5px' }}>
          <PrimaryButton
            title={translate({ ...messages.TelServiceDesk }, props)}
            background={BUTTON_COLORS.PRIMARY_BLUE}
            lefticon={<img src={callIcon} alt="CallIcon" />}
            border={BUTTON_COLORS.PRIMARY_BLUE}
            titleclass="title-button-secondary"
            style={{ width: '100%', height: '100%' }}
          />
        </div>
      </ButtonContainer>
    </div>
  </div>
);

export default injectIntl(RestrictedAccessPage);

export interface RestrictedAccessPageProps {
  intl: IntlShape;
}
